<template>
  <!-- 无操作列表  订单详情 -->

  <div class="hasData">
    <p class="tabtitle">投保地块信息</p>
    <el-table
      v-loading="loading"
      :data="rowInfoList"
      :header-cell-style="thClass"
      :cell-style="{ color: '#666666' }"
    >
      <el-table-column label="作物">
        <template slot-scope="scope">
          <span class="zuoweNameImg">
            <img :src="scope.row.cropGroupImgUrl" alt="" />
          </span>
          <span>{{ scope.row.cropGroupName }}</span>
        </template>
      </el-table-column>

      <el-table-column label="种植地块" width="260px">
        <template slot-scope="scope">
          <div class="itemLand">
            <span class="xzWeight" :title="scope.row.landName">
              {{ scope.row.landName }}
            </span>
            <span class="AcreMianJi">
              ({{
                scope.row.statisticsLandAcre == null
                  ? "0"
                  : scope.row.statisticsLandAcre
              }}
              亩)
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="种植时间" width="122px">
        <template slot-scope="scope">
          <span
            >{{ scope.row.plantStartDate | formatDate("yyyy-MM-dd") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="起保时间" width="122px">
        <template slot-scope="scope">
          <span
            >{{ scope.row.insureEffectiveStartDate | formatDate("yyyy-MM-dd") }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="终保时间" width="122px">
        <template slot-scope="scope">
          <span
            >{{ scope.row.insureEffectiveEndDate | formatDate("yyyy-MM-dd") }}
          </span>
        </template>
      </el-table-column>

      <el-table-column label="每亩自缴保费" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.selfPremiumUnit }}元 </span>
        </template>
      </el-table-column>
      <el-table-column label="自缴保费" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.selfPremiumTotal }}元 </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "tableListNo",

  created() {},
  props: {
    rowInfoList: {
      type: [Object, Array],
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },

  methods: {
    thClass() {
      return "background:#EEFFF9;color:#64C3A4;font-size:18px;";
    },
  },
};
</script>

<style lang="scss" scoped>
//表头高度
::v-deep .el-table__header tr,
.el-table__header th {
  height: 80px;
}

.tabtitle {
  font-weight: 700;
  color: #333;
  font-size: 18px;
  margin-bottom: 30px;
  text-align: center;
}
</style>
